"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIcon = getIcon;

var _Question = _interopRequireDefault(require("@tdcerhverv/parrotfish/dist/icons/Icons/Question.svg"));

var _Info = _interopRequireDefault(require("@tdcerhverv/parrotfish/dist/icons/Icons/Info.svg"));

var _Success = _interopRequireDefault(require("@tdcerhverv/parrotfish/dist/icons/Icons/Success.svg"));

var _Clear = _interopRequireDefault(require("@tdcerhverv/parrotfish/dist/icons/Icons/Clear.svg"));

var _Warning = _interopRequireDefault(require("@tdcerhverv/parrotfish/dist/icons/Icons/Warning.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getIcon(type) {
  if (type === 'info') {
    return _Info.default;
  }

  if (type === 'positive') {
    return _Success.default;
  }

  if (type === 'negative') {
    return _Clear.default;
  }

  if (type === 'warning') {
    return _Warning.default;
  }

  return _Question.default;
}